import { IPreCalculateActOtherEnergyResp } from './actOtherEnergy.type'

type Props = {
  data: IPreCalculateActOtherEnergyResp
}

/**
 * type1 和 powerinput 共用
 * type1: [fuelResp] 永遠只取第一個, powerinput 取 array 顯示
 */
export const convertIPreCalculateActOtherEnergyResp = (res: Props) => {
  const data = res?.data
  const fuels = data.fuels
  const convertData = data.otherEnergyResults.map(i => {
    const fuelResp = i.fuelResp.map(x => {
      const fuelDto = fuels.find(f => f.id === x.fuel)

      return { ...x, fuelDto }
    })

    return { ...i, fuelResp }
  })

  return convertData && convertData[0]
}
